import React, { Component } from "react";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import CircularProgress from "@material-ui/core/CircularProgress";
import Checkbox from "@material-ui/core/Checkbox";
import Grid from "@material-ui/core/Grid";
import { v1 as uuidv1 } from "uuid";
import axios from "axios";
import moment from "moment";
import {
  ShowRequiredField,
  ShowInvalidCode,
  SendEmailVerificationCode,
  GetAdmissionNumber,
  SendAttachment,
  SendAdmission,
  SendEmailSuccess,
  kPButton,
} from "../global";
import AdmissionContext from "../AdmissionContext";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";

class OthersView extends Component {
  static contextType = AdmissionContext;

  constructor(props) {
    super(props);

    this.state = {
      showVerficationDialog: false,
      showProcessDialog: false,
      showOnProcessDialog: false,
      showAlreadyExistDialog: false,
      showProcessErrorDialog: false,
      generatedTime: "",
      generatedCode: "",
      verificationCode: "",
      invalidCode: false,
      processValue: 0,
    };
  }

  componentDidMount() { }

  textfieldValueChanged = (index, event) => {
    const { others } = this.context;
    others.required = false;

    if (index === 0) {
      //faSpecify
      others.faSpecify = event.target.value;
    } else if (index === 1) {
      //igSpecify
      others.igSpecify = event.target.value;
    }

    this.context.SetOthers(others);
  };

  verificationCodeValueChanged = (event) => {
    this.setState({
      verificationCode: event.target.value,
      invalidCode: false,
    });
  };

  checkValueChanged = (index, value) => {
    const { others } = this.context;
    others.required = false;

    if (index === 0) {
      //fay
      others.fa = value;
      if (!value) {
        others.faSpecify = "";
      }
    } else if (index === 1) {
      //ig
      others.ig = value;
      if (!value) {
        others.igSpecify = "";
      }
    } else if (index === 2) {
      //sp
      others.sp = value;
    } else if (index === 3) {
      //pwd
      others.pwd = value;
    }

    this.context.SetOthers(others);
  };

  checkRequireFields = (index) => {
    const { others } = this.context;

    if (others.required) {
      if (index === 0) {
        if (others.fa) {
          if (others.faSpecify === "") {
            return ShowRequiredField("Pls. Specify");
          }
        }
      } else if (index === 1) {
        if (others.ig) {
          if (others.igSpecify === "") {
            return ShowRequiredField("Pls. Specify");
          }
        }
      }
    }

    return null;
  };

  backButtonClicked = () => {
    this.context.btnBackClicked();
  };

  submitButtonClicked = async () => {
    const { others, year, personalInformation } =
      this.context;

    if (others.fa) {
      if (others.faSpecify === "") {
        others.required = true;
        this.context.SetOthers(others);
        return;
      }
    }

    if (others.ig) {
      if (others.igSpecify === "") {
        others.required = true;
        this.context.SetOthers(others);
        return;
      }
    }

    this.setState({
      showVerficationDialog: false,
      showProcessDialog: false,
      showOnProcessDialog: true,
      showAlreadyExistDialog: false,
      showProcessErrorDialog: false,
    });

    //check if already exist
    new Promise(function (resolve, reject) {

      axios({
        method: "post",
        url: `${process.env.REACT_APP_API}/api/admission/validate`,
        headers: {
          "Content-type": "application/json",
          Accept: "application/json",
        },
        auth: {
          username: `${process.env.REACT_APP_USER}`,
          password: `${process.env.REACT_APP_PWD}`,
        },
        data: {
          year: year,
          lastName: personalInformation.lastName.toUpperCase().trim(),
          firstName: personalInformation.firstName.toUpperCase().trim(),
          middleName: personalInformation.middleName.toUpperCase().trim(),
          dateofBirth: personalInformation.dateofBirth,
        },
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });

    })
      .then((response) => {
        //check response
        if (Object.keys(response.data).length > 0) {
          //continue
          this.setState({
            showVerficationDialog: false,
            showProcessDialog: false,
            showOnProcessDialog: false,
            showAlreadyExistDialog: true,
            showProcessErrorDialog: false,
          });
        } else {

          //verify
          let code = parseInt(Math.random() * (900000 - 100000)).toString().padStart(6, "0");
          let time = parseInt(moment(new Date()).format("YYYYMMDDHHmmss"));

          //send Mail for verification
          SendEmailVerificationCode(this.context, code)
            .then((response) => {
              this.setState({
                showVerficationDialog: true,
                showProcessDialog: false,
                showOnProcessDialog: false,
                showAlreadyExistDialog: false,
                showProcessErrorDialog: false,
                generatedCode: code,
                generatedTime: time,
              });
            })
            .catch((error) => {
              //show error message
              this.setState({
                showVerficationDialog: false,
                showProcessDialog: false,
                showOnProcessDialog: false,
                showAlreadyExistDialog: false,
                showProcessErrorDialog: true,
                verificationCode: "",
              });

              return;
            });
        }
      })
      .catch((error) => {
        console.log(error)
        //error
        this.setState({
          showVerficationDialog: false,
          showProcessDialog: false,
          showOnProcessDialog: false,
          showAlreadyExistDialog: false,
          showProcessErrorDialog: true,
          verificationCode: "",
        });
      });
  };

  showFASpecify = () => {
    const { others } = this.context;
    if (others.fa) {
      return (
        <Box pt={2}>
          <TextField
            fullWidth={true}
            id="txtfaSpecify"
            label="Please specify"
            variant="outlined"
            value={others.faSpecify}
            onChange={(e) => {
              this.textfieldValueChanged(0, e);
            }}
          />
        </Box>
      );
    }
  };

  showIGSpecify = () => {
    const { others } = this.context;
    if (others.ig) {
      return (
        <Box pt={2}>
          <TextField
            fullWidth={true}
            id="txtigSpecify"
            label="Please specify"
            variant="outlined"
            value={others.igSpecify}
            onChange={(e) => {
              this.textfieldValueChanged(1, e);
            }}
          />
        </Box>
      );
    }
  };

  verifyCode = async () => {
    const { generatedCode, generatedTime, verificationCode } = this.state;
    const { database, attachment } = this.context;

    //check code
    if (generatedCode !== verificationCode) {
      this.setState({
        invalidCode: true,
      });
      return;
    }

    //check expired
    let verificationTime = parseInt(
      moment(new Date()).subtract(5, "minutes").format("YYYYMMDDHHmmss")
    );

    if (generatedTime < verificationTime) {
      this.setState({
        invalidCode: true,
      });
      return;
    }

    this.setState({
      showVerficationDialog: false,
      showProcessDialog: true,
      processValue: 0,
      processItemCount: 0,
    });

    //get admission number
    var ano = await GetAdmissionNumber(this.context);
    var docAno = `${process.env.REACT_APP_AY_ANO}${ano.data.an
      .toString()
      .padStart(5, "0")}`;
    var docAid = uuidv1();

    //10%
    this.setState({
      processValue: 10,
    });

    try {
      //send attachment
      // 0:imgGoodMoral
      // 1:imgBirthCertificate
      // 2:imgReportCard
      // 3:imgPicture
      // 4:imgCopyofTOR

      if (attachment.imgGoodMoral.length > 0) {
        if (attachment.imgGoodMoral[0] !== "") {
          await SendAttachment(database, uuidv1(), {
            _id: docAid,
            ano: docAno,
            ern: "",
            sno: "",
            file: attachment.imgGoodMoral[0],
            fileIndex: 0, //good moral
            txnDate: moment(new Date()).format("YYYYMMDDHHmmss"),
          })
            .then(() => {
              //complete
            })
            .catch((error) => {
              throw new Error(error);
            });
        }

        this.setState({
          processValue: 10,
        });
      }

      //Birth Certificate
      if (attachment.imgBirthCertificate.length > 0) {
        if (attachment.imgBirthCertificate[0] !== "") {
          await SendAttachment(database, uuidv1(), {
            _id: docAid,
            ano: docAno,
            ern: "",
            sno: "",
            file: attachment.imgBirthCertificate[0],
            fileIndex: 1, //Birth Certificate
            txnDate: moment(new Date()).format("YYYYMMDDHHmmss"),
          })
            .then(() => {
              //complete
            })
            .catch((error) => {
              throw new Error(error);
            });
        }

        this.setState({
          processValue: 20,
        });
      }

      //Report Card
      if (attachment.imgReportCard.length > 0) {
        if (attachment.imgReportCard[0] !== "") {
          await SendAttachment(database, uuidv1(), {
            _id: docAid,
            ano: docAno,
            ern: "",
            sno: "",
            file: attachment.imgReportCard[0],
            fileIndex: 2, //Report Card
            txnDate: moment(new Date()).format("YYYYMMDDHHmmss"),
          })
            .then(() => {
              //complete
            })
            .catch((error) => {
              throw new Error(error);
            });
        }

        this.setState({
          processValue: 30,
        });
      }

      //1x1 Picture
      if (attachment.imgPicture.length > 0) {
        if (attachment.imgPicture[0] !== "") {
          await SendAttachment(database, uuidv1(), {
            _id: docAid,
            ano: docAno,
            ern: "",
            sno: "",
            file: attachment.imgPicture[0],
            fileIndex: 3, //Picture
            txnDate: moment(new Date()).format("YYYYMMDDHHmmss"),
          })
            .then(() => {
              //complete
            })
            .catch((error) => {
              throw new Error(error);
            });
        }

        this.setState({
          processValue: 40,
        });
      }

      //CopyofTOR
      if (attachment.imgCopyofTOR.length > 0) {
        if (attachment.imgCopyofTOR[0] !== "") {
          await SendAttachment(database, uuidv1(), {
            _id: uuidv1(),
            ano: docAno,
            ern: "",
            sno: "",
            file: attachment.imgCopyofTOR[0],
            fileIndex: 4, //CopyofTOR
            txnDate: moment(new Date()).format("YYYYMMDDHHmmss"),
          })
            .then(() => {
              //complete
            })
            .catch((error) => {
              throw new Error(error);
            });
        }

        this.setState({
          processValue: 50,
        });
      }

      //Clearance
      if (attachment.imgClearance.length > 0) {
        if (attachment.imgClearance[0] !== "") {
          await SendAttachment(database, uuidv1(), {
            _id: uuidv1(),
            ano: docAno,
            ern: "",
            sno: "",
            file: attachment.imgClearance[0],
            fileIndex: 5, //Clearance
            txnDate: moment(new Date()).format("YYYYMMDDHHmmss"),
          })
            .then(() => {
              //complete
            })
            .catch((error) => {
              throw new Error(error);
            });
        }

        this.setState({
          processValue: 60,
        });
      }

      //Evaluation
      if (attachment.imgEvaluation.length > 0) {
        if (attachment.imgEvaluation[0] !== "") {
          await SendAttachment(database, uuidv1(), {
            _id: uuidv1(),
            ano: docAno,
            ern: "",
            sno: "",
            file: attachment.imgEvaluation[0],
            fileIndex: 6, //Evaluation
            txnDate: moment(new Date()).format("YYYYMMDDHHmmss"),
          })
            .then(() => {
              //complete
            })
            .catch((error) => {
              throw new Error(error);
            });
        }

        this.setState({
          processValue: 70,
        });
      }


      await SendAdmission(this.context, docAno, docAid)
        .then(() => {
          this.setState({
            processValue: 80,
          });

          SendEmailSuccess(this.context, docAno)
            .then(() => {
              this.setState({
                processValue: 100,
              });

              this.setState({
                showProcessDialog: false,
              });

              //save ano and set stepper
              this.context.SetAno(docAno);
              this.context.btnNextClicked();
            })
            .catch((error) => {
              console.log(error)
              throw new Error(error);
            });
        })
        .catch((error) => {
          console.log(error)
          throw new Error(error);
        });
    } catch (error) {
      this.setState({
        showVerficationDialog: false,
        showProcessDialog: false,
        showOnProcessDialog: false,
        showAlreadyExistDialog: false,
        showProcessErrorDialog: true,
        verificationCode: "",
      });
    }
  };

  showInvalidCode = () => {
    if (this.state.invalidCode) {
      return ShowInvalidCode();
    }
  };

  showVerificationDialog = () => {
    const { contact } = this.context;
    return (
      <Dialog
        open={this.state.showVerficationDialog}
        style={{
          position: "absolute",
          left: 10,
          top: 50,
        }}
      >
        <Grid>
          <Grid item xs={12}>
            <Box
              pt={3}
              pl={3}
              pr={3}
              fontWeight={600}
              justifyContent="center"
              display="flex"
              fontSize={20}
              color="#388e3c"
            >
              EMAIL VERIFICATION CODE
            </Box>
            <Box pt={2} pl={3} pr={3}>
              We have send a code to your email ({contact.email}) for
              verification.
            </Box>
            <Box
              //pt={1}
              pl={3}
              pr={3}
            >
              (If the email is not found in the Inbox, kindly check your SPAM
              box)
            </Box>
            <Box pt={2} pb={2} pl={3} pr={3}>
              <TextField
                autoFocus
                variant="outlined"
                value={this.state.verificationCode}
                onChange={(e) => {
                  this.verificationCodeValueChanged(e);
                }}
                id="txtVerificationCode"
                label="Code"
                fullWidth={true}
              />

              {this.showInvalidCode()}
            </Box>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={2} sm={2} lg={2}></Grid>
          <Grid item xs={4} sm={4} lg={4}>
            <Box pr={2}>
              <Button
                fullWidth={true}
                style={kPButton}
                variant="contained"
                onClick={() => {
                  this.setState({ showVerficationDialog: false });
                }}
              >
                Cancel
              </Button>
            </Box>
          </Grid>
          <Grid item xs={4} sm={4} lg={4}>
            <Box pr={2}>
              <Button
                fullWidth={true}
                style={kPButton}
                variant="contained"
                onClick={() => {
                  this.verifyCode();
                }}
              >
                Verify
              </Button>
            </Box>
          </Grid>
          <Grid item xs={2} sm={2} lg={2}></Grid>
        </Grid>

        <Box pt={3}></Box>
      </Dialog>
    );
  };

  showAlreadyExitsDialog = () => {
    const { personalInformation } = this.context;

    return (
      <Dialog
        open={this.state.showAlreadyExistDialog}
        style={{
          position: "absolute",
          left: 10,
          top: 50,
        }}
      >
        <Grid>
          <Grid item xs={12}>
            <Box
              pt={3}
              pl={3}
              pr={3}
              fontWeight={600}
              justifyContent="center"
              display="flex"
              fontSize={20}
              color="error.main"
            >
              VALIDATION ERROR
            </Box>
            <Box pt={2} pl={3} pr={3}>
              Personal Information data already exist.
            </Box>

            <Box pt={2} pl={4} pr={3}>
              {personalInformation.lastName}, {personalInformation.firstName}{" "}
              {personalInformation.middleName}
            </Box>
            <Box pt={1} pl={4} pr={3}>
              {personalInformation.dateofBirth}
            </Box>
            <Box pt={2} pl={3} pr={3}>
              Please contact DLSP MIS office admissionofficedlsp@gmail.com.
            </Box>
          </Grid>
        </Grid>

        <Grid container>
          <Grid item xs={4} sm={4} lg={4}></Grid>
          <Grid item xs={4} sm={4} lg={4}>
            <Box pt={2} pb={3}>
              <Button
                fullWidth={true}
                style={kPButton}
                variant="contained"
                onClick={() => {
                  this.setState({ showAlreadyExistDialog: false });
                }}
              >
                OK
              </Button>
            </Box>
          </Grid>
          <Grid item xs={4} sm={4} lg={4}></Grid>
        </Grid>
      </Dialog>
    );
  };

  showProcessDialog = () => {
    return (
      <Dialog
        open={this.state.showProcessDialog}
        style={{
          position: "absolute",
          left: 10,
          top: 50,
        }}
      >
        <Box
          pt={3}
          fontWeight={600}
          justifyContent="center"
          display="flex"
          fontSize={20}
          color="#388e3c"
        >
          PROCESSING
        </Box>

        <DialogContent style={{ height: "100%" }}>
          <Box pt={4}></Box>
          <Box
            position="relative"
            display="inline-flex"
            minWidth={300}
            justifyContent="center"
          >
            <CircularProgress
              variant="determinate"
              value={this.state.processValue}
              size={50}
            />
            <Box
              top={0}
              left={0}
              bottom={0}
              right={0}
              position="absolute"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              {`${this.state.processValue}%`}
            </Box>
          </Box>

          <Box display="flex" justifyContent="center" pt={2}>
            <Box display="flex" alignItems="center" justifyContent="center">
              Please wait
            </Box>
          </Box>

          <Box pt={4}></Box>
        </DialogContent>
      </Dialog>
    );
  };

  showOnProcessDialog = () => {
    return (
      <Dialog
        open={this.state.showOnProcessDialog}
        style={{
          position: "absolute",
          left: 10,
          top: 50,
        }}
      >
        <Box
          pt={3}
          fontWeight={600}
          justifyContent="center"
          display="flex"
          fontSize={20}
          color="#388e3c"
        >
          VALIDATING
        </Box>

        <DialogContent style={{ height: "100%" }}>
          <Box pt={4}></Box>
          <Box
            position="relative"
            display="inline-flex"
            minWidth={300}
            justifyContent="center"
          >
            <CircularProgress variant="indeterminate" disableShrink size={50} />
          </Box>

          <Box display="flex" justifyContent="center" pt={2}>
            <Box display="flex" alignItems="center" justifyContent="center">
              Please wait
            </Box>
          </Box>

          <Box pt={4}></Box>
        </DialogContent>
      </Dialog>
    );
  };

  showProcessErrorDialog = () => {
    return (
      <Dialog
        open={this.state.showProcessErrorDialog}
        style={{
          position: "absolute",
          left: 10,
          top: 50,
        }}
      >
        <Grid>
          <Grid item xs={12}>
            <Box
              pt={3}
              pl={3}
              pr={3}
              fontWeight={600}
              justifyContent="center"
              display="flex"
              fontSize={20}
              color="error.main"
            >
              PROCESS ERROR
            </Box>
            <Box pt={2} pl={3} pr={3}>
              Please try again!
            </Box>
          </Grid>
        </Grid>

        <Grid container>
          <Grid item xs={4} sm={4} lg={4}></Grid>
          <Grid item xs={4} sm={4} lg={4}>
            <Box pt={2} pb={3}>
              <Button
                fullWidth={true}
                style={kPButton}
                variant="contained"
                onClick={() => {
                  this.setState({ showProcessErrorDialog: false });
                }}
              >
                OK
              </Button>
            </Box>
          </Grid>
          <Grid item xs={4} sm={4} lg={4}></Grid>
        </Grid>
      </Dialog>
    );
  };

  render() {
    const { others } = this.context;

    return (
      <Box display="flex" justifyContent="center" pt={2}>
        <Grid container spacing={1}>
          <Grid item xs={1} sm={2} lg={3}></Grid>
          <Grid item xs={10} sm={8} lg={6}>
            <Card
              style={{
                border: 0,
                // minWidth: 500,
                // maxWidth: 600,
              }}
              variant="outlined"
            >
              <CardContent>
                <Typography component="div">
                  <Box
                    fontWeight={500}
                    fontSize={18}
                    color="#388e3c"
                    display="flex"
                    justifyContent="flex-start"
                  >
                    Others
                  </Box>
                </Typography>

                <Box fontSize={14} color="#808080" display="flex" pt={1}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="chkfa"
                        checked={others.fa}
                        onChange={(e) => {
                          this.checkValueChanged(0, e.target.checked);
                        }}
                        style={{
                          color: "#388e3c",
                        }}
                      />
                    }
                    label="Are you enjoying other educational/financial assistance?"
                  />
                </Box>

                {/* specify */}
                {this.showFASpecify()}
                {this.checkRequireFields(0)}

                <Box fontSize={14} color="#808080" display="flex" pt={1}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="chkfa"
                        checked={others.ig}
                        onChange={(e) => {
                          this.checkValueChanged(1, e.target.checked);
                        }}
                        style={{
                          color: "#388e3c",
                        }}
                      />
                    }
                    label="Are you a member of any indigenous group?"
                  />
                </Box>

                {/* specify */}
                {this.showIGSpecify()}
                {this.checkRequireFields(1)}

                <Box fontSize={14} color="#808080" display="flex" pt={1}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="chkfa"
                        checked={others.sp}
                        onChange={(e) => {
                          this.checkValueChanged(2, e.target.checked);
                        }}
                        style={{
                          color: "#388e3c",
                        }}
                      />
                    }
                    label="Are you a solo parent?"
                  />
                </Box>

                <Box fontSize={14} color="#808080" display="flex" pt={1}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="chkfa"
                        checked={others.pwd}
                        onChange={(e) => {
                          this.checkValueChanged(3, e.target.checked);
                        }}
                        style={{
                          color: "#388e3c",
                        }}
                      />
                    }
                    label="Are you a person with disability?"
                  />
                </Box>

                <Typography component="div">
                  <Box
                    fontWeight={500}
                    fontSize={18}
                    color="#388e3c"
                    display="flex"
                    justifyContent="flex-start"
                    pt={4}
                  >
                    I hereby certify that all the information are true and
                    correct.
                  </Box>
                </Typography>

                {this.showVerificationDialog()}
                {this.showAlreadyExitsDialog()}
                {this.showProcessDialog()}
                {this.showOnProcessDialog()}
                {this.showProcessErrorDialog()}

                {/* BUTTON */}

                <Box
                  justifyContent="center"
                  display="flex"
                  pt={4}
                  fontSize={14}
                >
                  <Box width={200} justifyContent="flex-start">
                    <Button
                      fullWidth={true}
                      style={kPButton}
                      variant="contained"
                      onClick={() => {
                        this.backButtonClicked();
                      }}
                    >
                      Back
                    </Button>
                  </Box>

                  <Box width={200} minHeight={100} pl={2}>
                    <Button
                      fullWidth={true}
                      style={kPButton}
                      variant="contained"
                      onClick={() => {
                        this.submitButtonClicked();
                      }}
                    >
                      Submit
                    </Button>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={1} sm={2} lg={3}></Grid>
        </Grid>
      </Box>
    );
  }
}

export default OthersView;
